// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SnohAI sign-in — split brand panel + form */

:root {
  --snoh-blue: #0f6fd4;
  --snoh-blue-bright: #2b8cf0;
  --snoh-blue-deep: #072a5e;
  --snoh-orange: #e9620f;
  --snoh-orange-light: #ff9a4d;
  --snoh-ink: #0e1a2b;
  --snoh-muted: #5c6e88;
  --snoh-line: #dde5f0;
  --snoh-surface: #ffffff;
  --snoh-danger: #b3261e;

  --snoh-display: 'Outfit', 'Segoe UI', Tahoma, sans-serif;
  --snoh-body: 'Plus Jakarta Sans', 'Segoe UI', Tahoma, sans-serif;
}

body {
  margin: 0;
  font-family: var(--snoh-body);
  color: var(--snoh-ink);
  background-color: var(--snoh-surface);
  -webkit-font-smoothing: antialiased;
}

.snoh-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  min-height: 100vh;
  min-height: 100dvh;
  text-align: left;
}

/* ---------- Brand panel ---------- */

.snoh-brand {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 64px clamp(40px, 6vw, 88px);
  color: #ffffff;
  background:
    radial-gradient(58% 46% at 110% 114%, rgba(233, 98, 15, 0.96) 0%, rgba(233, 98, 15, 0.34) 46%, rgba(233, 98, 15, 0) 72%),
    radial-gradient(80% 65% at -12% -14%, rgba(43, 140, 240, 0.62) 0%, rgba(43, 140, 240, 0) 62%),
    linear-gradient(160deg, #061f47 0%, #0d55ae 60%, #08346f 100%);
}

.snoh-brand-inner {
  position: relative;
  width: 100%;
  max-width: 540px;
}

.snoh-eyebrow {
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--snoh-orange-light);
}

.snoh-headline {
  margin: 0;
  font-family: var(--snoh-display);
  font-size: clamp(30px, 3vw, 40px);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.16;
  color: #ffffff;
}

/* ---------- Form panel ---------- */

.snoh-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px clamp(24px, 5vw, 72px);
  background: var(--snoh-surface);
}

.snoh-form-wrap {
  width: 100%;
  max-width: 380px;
  animation: snoh-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes snoh-rise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
}

/* The source PNG carries generous transparent padding, so it is sized
   larger than its optical width and pulled back into the left margin. */
.snoh-logo {
  display: block;
  width: 272px;
  max-width: 116%;
  margin: -20px 0 -8px -62px;
}

.snoh-title {
  margin: 0;
  font-family: var(--snoh-display);
  font-size: 34px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--snoh-ink);
}

.snoh-subtitle {
  margin: 10px 0 32px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--snoh-muted);
}

.snoh-form {
  display: flex;
  flex-direction: column;
}

.snoh-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--snoh-ink);
  margin-bottom: 8px;
}

.snoh-input {
  width: 100%;
  padding: 14px 16px;
  font-family: inherit;
  font-size: 15px;
  color: var(--snoh-ink);
  background: var(--snoh-surface);
  border: 1px solid var(--snoh-line);
  border-radius: 10px;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.snoh-input::placeholder {
  color: #9aa8bd;
}

.snoh-input:hover:not(:disabled) {
  border-color: #c3d0e2;
}

.snoh-input:focus {
  outline: none;
  border-color: var(--snoh-blue);
  box-shadow: 0 0 0 4px rgba(15, 111, 212, 0.15);
}

.snoh-input:disabled {
  background: #f6f8fb;
  color: var(--snoh-muted);
  cursor: not-allowed;
}

.snoh-input--invalid {
  border-color: var(--snoh-danger);
}

.snoh-input--invalid:focus {
  border-color: var(--snoh-danger);
  box-shadow: 0 0 0 4px rgba(179, 38, 30, 0.14);
}

/* Reserved so the layout does not jump when a message appears */
.snoh-error {
  min-height: 18px;
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--snoh-danger);
}

.snoh-help-link {
  align-self: flex-start;
  margin: 14px 0 24px;
  font-size: 13px;
  font-weight: 500;
  color: var(--snoh-blue);
  text-decoration: none;
}

.snoh-help-link:hover {
  text-decoration: underline;
}

.snoh-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 20px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  background: var(--snoh-blue);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.snoh-submit:hover:not(:disabled) {
  background: #0c5cb0;
  box-shadow: 0 8px 20px rgba(15, 111, 212, 0.28);
}

.snoh-submit:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: none;
}

.snoh-submit:disabled {
  opacity: 0.72;
  cursor: progress;
}

.snoh-arrow {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.18s ease;
}

.snoh-submit:hover:not(:disabled) .snoh-arrow {
  transform: translateX(3px);
}

.snoh-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: snoh-spin 0.7s linear infinite;
}

@keyframes snoh-spin {
  to {
    transform: rotate(360deg);
  }
}

.snoh-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid var(--snoh-line);
  font-size: 12px;
  color: #94a2b7;
}

.snoh-footer a {
  color: #94a2b7;
  text-decoration: none;
}

.snoh-footer a:hover {
  color: var(--snoh-blue);
  text-decoration: underline;
}

/* ---------- Focus visibility ---------- */

.snoh-page a:focus-visible,
.snoh-submit:focus-visible {
  outline: 2px solid var(--snoh-blue);
  outline-offset: 3px;
  border-radius: 4px;
}

.snoh-brand a:focus-visible {
  outline-color: #ffffff;
}

/* ---------- Responsive ---------- */

@media (max-width: 1024px) {
  .snoh-brand {
    padding: 56px 40px;
  }
}

@media (max-width: 880px) {
  .snoh-page {
    grid-template-columns: minmax(0, 1fr);
    /* Without this the auto rows stretch and the brand band eats the screen */
    grid-template-rows: auto 1fr;
  }

  .snoh-brand {
    align-items: flex-end;
    min-height: 210px;
    padding: 32px 28px;
  }

  .snoh-eyebrow {
    margin-bottom: 10px;
  }

  .snoh-headline {
    font-size: 26px;
  }

  .snoh-panel {
    padding: 44px 28px 56px;
    justify-content: flex-start;
  }

  .snoh-form-wrap {
    max-width: 440px;
    margin: 0 auto;
  }

  .snoh-logo {
    width: 240px;
    margin: -14px 0 22px -26px;
  }
}

@media (max-width: 420px) {
  .snoh-brand {
    min-height: 168px;
  }

  .snoh-headline {
    font-size: 22px;
  }

  .snoh-title {
    font-size: 28px;
  }

  .snoh-subtitle {
    font-size: 14px;
    margin-bottom: 26px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .snoh-form-wrap {
    animation: none;
  }

  .snoh-submit,
  .snoh-arrow,
  .snoh-input {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EmailForm.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;;EAEtB,wDAAwD;EACxD,gEAAgE;AAClE;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,sBAAsB;EACtB,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd;;;kEAGgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;wEACwE;AACxE;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,2CAA2C;;AAE3C;;EAEE,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qCAAqC;;AAErC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,0EAA0E;IAC1E,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* SnohAI sign-in — split brand panel + form */\n\n:root {\n  --snoh-blue: #0f6fd4;\n  --snoh-blue-bright: #2b8cf0;\n  --snoh-blue-deep: #072a5e;\n  --snoh-orange: #e9620f;\n  --snoh-orange-light: #ff9a4d;\n  --snoh-ink: #0e1a2b;\n  --snoh-muted: #5c6e88;\n  --snoh-line: #dde5f0;\n  --snoh-surface: #ffffff;\n  --snoh-danger: #b3261e;\n\n  --snoh-display: 'Outfit', 'Segoe UI', Tahoma, sans-serif;\n  --snoh-body: 'Plus Jakarta Sans', 'Segoe UI', Tahoma, sans-serif;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--snoh-body);\n  color: var(--snoh-ink);\n  background-color: var(--snoh-surface);\n  -webkit-font-smoothing: antialiased;\n}\n\n.snoh-page {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  min-height: 100vh;\n  min-height: 100dvh;\n  text-align: left;\n}\n\n/* ---------- Brand panel ---------- */\n\n.snoh-brand {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  padding: 64px clamp(40px, 6vw, 88px);\n  color: #ffffff;\n  background:\n    radial-gradient(58% 46% at 110% 114%, rgba(233, 98, 15, 0.96) 0%, rgba(233, 98, 15, 0.34) 46%, rgba(233, 98, 15, 0) 72%),\n    radial-gradient(80% 65% at -12% -14%, rgba(43, 140, 240, 0.62) 0%, rgba(43, 140, 240, 0) 62%),\n    linear-gradient(160deg, #061f47 0%, #0d55ae 60%, #08346f 100%);\n}\n\n.snoh-brand-inner {\n  position: relative;\n  width: 100%;\n  max-width: 540px;\n}\n\n.snoh-eyebrow {\n  margin: 0 0 16px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--snoh-orange-light);\n}\n\n.snoh-headline {\n  margin: 0;\n  font-family: var(--snoh-display);\n  font-size: clamp(30px, 3vw, 40px);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.16;\n  color: #ffffff;\n}\n\n/* ---------- Form panel ---------- */\n\n.snoh-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 64px clamp(24px, 5vw, 72px);\n  background: var(--snoh-surface);\n}\n\n.snoh-form-wrap {\n  width: 100%;\n  max-width: 380px;\n  animation: snoh-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes snoh-rise {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n}\n\n/* The source PNG carries generous transparent padding, so it is sized\n   larger than its optical width and pulled back into the left margin. */\n.snoh-logo {\n  display: block;\n  width: 272px;\n  max-width: 116%;\n  margin: -20px 0 -8px -62px;\n}\n\n.snoh-title {\n  margin: 0;\n  font-family: var(--snoh-display);\n  font-size: 34px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--snoh-ink);\n}\n\n.snoh-subtitle {\n  margin: 10px 0 32px;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--snoh-muted);\n}\n\n.snoh-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.snoh-label {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--snoh-ink);\n  margin-bottom: 8px;\n}\n\n.snoh-input {\n  width: 100%;\n  padding: 14px 16px;\n  font-family: inherit;\n  font-size: 15px;\n  color: var(--snoh-ink);\n  background: var(--snoh-surface);\n  border: 1px solid var(--snoh-line);\n  border-radius: 10px;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.snoh-input::placeholder {\n  color: #9aa8bd;\n}\n\n.snoh-input:hover:not(:disabled) {\n  border-color: #c3d0e2;\n}\n\n.snoh-input:focus {\n  outline: none;\n  border-color: var(--snoh-blue);\n  box-shadow: 0 0 0 4px rgba(15, 111, 212, 0.15);\n}\n\n.snoh-input:disabled {\n  background: #f6f8fb;\n  color: var(--snoh-muted);\n  cursor: not-allowed;\n}\n\n.snoh-input--invalid {\n  border-color: var(--snoh-danger);\n}\n\n.snoh-input--invalid:focus {\n  border-color: var(--snoh-danger);\n  box-shadow: 0 0 0 4px rgba(179, 38, 30, 0.14);\n}\n\n/* Reserved so the layout does not jump when a message appears */\n.snoh-error {\n  min-height: 18px;\n  margin: 8px 0 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--snoh-danger);\n}\n\n.snoh-help-link {\n  align-self: flex-start;\n  margin: 14px 0 24px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--snoh-blue);\n  text-decoration: none;\n}\n\n.snoh-help-link:hover {\n  text-decoration: underline;\n}\n\n.snoh-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 14px 20px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  background: var(--snoh-blue);\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.snoh-submit:hover:not(:disabled) {\n  background: #0c5cb0;\n  box-shadow: 0 8px 20px rgba(15, 111, 212, 0.28);\n}\n\n.snoh-submit:active:not(:disabled) {\n  transform: translateY(1px);\n  box-shadow: none;\n}\n\n.snoh-submit:disabled {\n  opacity: 0.72;\n  cursor: progress;\n}\n\n.snoh-arrow {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.18s ease;\n}\n\n.snoh-submit:hover:not(:disabled) .snoh-arrow {\n  transform: translateX(3px);\n}\n\n.snoh-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: snoh-spin 0.7s linear infinite;\n}\n\n@keyframes snoh-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.snoh-footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid var(--snoh-line);\n  font-size: 12px;\n  color: #94a2b7;\n}\n\n.snoh-footer a {\n  color: #94a2b7;\n  text-decoration: none;\n}\n\n.snoh-footer a:hover {\n  color: var(--snoh-blue);\n  text-decoration: underline;\n}\n\n/* ---------- Focus visibility ---------- */\n\n.snoh-page a:focus-visible,\n.snoh-submit:focus-visible {\n  outline: 2px solid var(--snoh-blue);\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n.snoh-brand a:focus-visible {\n  outline-color: #ffffff;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1024px) {\n  .snoh-brand {\n    padding: 56px 40px;\n  }\n}\n\n@media (max-width: 880px) {\n  .snoh-page {\n    grid-template-columns: minmax(0, 1fr);\n    /* Without this the auto rows stretch and the brand band eats the screen */\n    grid-template-rows: auto 1fr;\n  }\n\n  .snoh-brand {\n    align-items: flex-end;\n    min-height: 210px;\n    padding: 32px 28px;\n  }\n\n  .snoh-eyebrow {\n    margin-bottom: 10px;\n  }\n\n  .snoh-headline {\n    font-size: 26px;\n  }\n\n  .snoh-panel {\n    padding: 44px 28px 56px;\n    justify-content: flex-start;\n  }\n\n  .snoh-form-wrap {\n    max-width: 440px;\n    margin: 0 auto;\n  }\n\n  .snoh-logo {\n    width: 240px;\n    margin: -14px 0 22px -26px;\n  }\n}\n\n@media (max-width: 420px) {\n  .snoh-brand {\n    min-height: 168px;\n  }\n\n  .snoh-headline {\n    font-size: 22px;\n  }\n\n  .snoh-title {\n    font-size: 28px;\n  }\n\n  .snoh-subtitle {\n    font-size: 14px;\n    margin-bottom: 26px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .snoh-form-wrap {\n    animation: none;\n  }\n\n  .snoh-submit,\n  .snoh-arrow,\n  .snoh-input {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
